//export const server = 'https://sandbox.kbn.co.id'
export const server_detail_eproc = 'https://eproc.kbn.co.id'
//export const server_detail_eproc = 'https://dev.integra.id/eproc-kbn-dev'
 export const server = 'https://kbn.co.id'
// export const server = 'http://localhost:8888'
// export const server = 'http://172.16.110.204:8888'
